import { render } from "./CurrentCustomCover.vue?vue&type=template&id=0db18d5a"
import script from "./CurrentCustomCover.vue?vue&type=script&lang=js"
export * from "./CurrentCustomCover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__